<script lang="ts">
  import Modal from '../control/Modal.svelte';
  import type { ExercisePanelProps } from '$lib/types/articleTypes';
  import CirclePause from '../../../assets/svgs/circle-pause.svelte';
  import CirclePlayFilled from '../../../assets/svgs/circle-play-filled.svelte';
  import Play from '../../../assets/svgs/play.svelte';
  import Mute from '../../../assets/svgs/mute.svelte';
  import Volume from '../../../assets/svgs/volume.svelte';
  export let title: ExercisePanelProps['title'];
  export let details: ExercisePanelProps['details'];
  export let exerciseVideo: ExercisePanelProps['exerciseVideo'];
  export let panelContent: ExercisePanelProps['contentType'];

  let showModal = false;
  let muted = true;
  let paused = true;
  let modalMuted = false;
  let modalPaused = true;

  $: if (!showModal) {
    modalPaused = true;
    modalMuted = true;
  } else {
    paused = true;
    muted = true;
    modalMuted = false;
    modalPaused = false;
  }
</script>

{#if !panelContent}
  <section class="flex flex-col gap-8 lg:px-0 lg:gap-5">
    <div class="flex flex-row justify-between">
      {#if details !== null}
        <p class="text-gray-500 text-lg sm:text-xl font-medium break-words">
          {details}
        </p>
      {/if}
    </div>
    <div class="relative">
      <video
        on:click={() => {
          showModal = true;
        }}
        bind:paused
        bind:muted
        autoplay
        playsinline
        loop
        class="aspect-auto object-cover video-border rounded-xl w-full h-full"
      >
        <!-- The #t=0.1 is needed for iphones. Without it the video won't load the first frame -->
        <source src={`${exerciseVideo.url}#t=0.1`} />
        <track kind="captions" />
        <p>{exerciseVideo.title}</p>
      </video>
      <button
        class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 hidden sm:block"
        style="-webkit-tap-highlight-color: transparent;"
        on:click={() => {
          paused = !paused;
        }}
      >
        {#if paused}
          <CirclePlayFilled width={48} height={48} />
        {:else}
          <CirclePause width={48} height={48} />
        {/if}
      </button>
      <button
        class="absolute right-12 bottom-3 block sm:hidden"
        style="-webkit-tap-highlight-color: transparent;"
        on:click={() => {
          paused = !paused;
        }}
      >
        {#if paused}
          <CirclePlayFilled />
        {:else}
          <CirclePause />
        {/if}
      </button>
      <button
        class="absolute right-3 bottom-3"
        style="-webkit-tap-highlight-color: transparent;"
        on:click={() => {
          muted = !muted;
        }}
      >
        {#if muted}
          <Mute />
        {:else}
          <Volume />
        {/if}
      </button>
    </div>

    <Modal bind:showModal>
      <div class="relative">
        <video
          autoplay
          playsinline
          loop
          controls
          bind:muted={modalMuted}
          bind:paused={modalPaused}
          class="aspect-auto object-cover video-border rounded-xl w-full"
        >
          <source src={exerciseVideo.url} />
          <track kind="captions" />
          <p>{exerciseVideo.title}</p>
        </video>
      </div>
    </Modal>
  </section>
{:else}
  <section class="flex flex-row border-0 sm:border-b sm:border-gray-100 px-4 py-4 lg:pb-4 lg:px-0">
    <div class="w-3/5 sm:w-1/2 pr-4 md:pr-8">
      <div class="relative">
        <video
          on:click={() => {
            showModal = true;
          }}
          loop
          muted
          autoplay
          playsinline
          bind:paused
          class="aspect-auto object-cover video-border rounded-xl w-full"
        >
          <!-- The #t=0.1 is needed for iphones. Without it the video won't load the first frame -->
          <source src={`${exerciseVideo.url}#t=0.1`} />
          <track kind="captions" />
          <p>{exerciseVideo.title}</p>
        </video>
        <button
          class="hidden sm:block absolute right-0 bottom-0 m-3"
          style="-webkit-tap-highlight-color: transparent;"
          on:click={() => {
            paused = !paused;
          }}
        >
          {#if paused}
            <CirclePlayFilled />
          {:else}
            <CirclePause />
          {/if}
        </button>
      </div>

      <Modal bind:showModal>
        <div class="relative">
          <video
            autoplay
            playsinline
            muted
            loop
            controls
            class="aspect-auto object-cover video-border rounded-xl w-full"
          >
            <source src={exerciseVideo.url} />
            <track kind="captions" />
            <p>{exerciseVideo.title}</p>
          </video>
        </div>
      </Modal>
    </div>
    <div class="w-2/5 sm:w-1/2 flex flex-col justify-center items-start">
      <h3 class="text-gray-900 text-md sm:text-xxl font-semibold break-words">
        {title}
      </h3>
      {#if details !== null}
        <p class="text-gray-500 text-sm sm:text-xl font-medium break-words">
          {details}
        </p>
      {/if}
    </div>
  </section>
{/if}

<style>
  /* This is to remove the black border that appears on the bottom side of the video */
  .video-border {
    clip-path: inset(0px 0px 1px);
  }
</style>
